import React, { useState } from 'react';
import { FaSyringe, FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';

const NeedleStickInjuryForm = ({ handleFormSubmission, handleNeedleStickInjuryChange }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      handleFormSubmission(e);
      setIsSubmitting(false);
    }, 100);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-2xl">
        {/* Header */}
        <div className="mb-8 text-center">
          <div className="inline-flex size-16 items-center justify-center rounded-full bg-red-100">
            <FaSyringe className="size-8 text-red-600" aria-hidden="true" />
          </div>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Needle Stick Injury Report
          </h1>
          <p className="mt-2 text-base text-gray-600">
            Report needle stick injuries and exposure incidents
          </p>
        </div>

        {/* Form Card */}
        <div className="overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-gray-900/5">
          <form onSubmit={handleSubmit}>
            <div className="px-6 py-8 sm:px-10 sm:py-10">
              {/* Injury Details Section */}
              <div>
                <label htmlFor="needleStickInjury" className="flex items-center gap-2 text-sm font-semibold text-gray-900 mb-4">
                  <FaExclamationTriangle className="size-4 text-gray-400" />
                  Injury Details
                  <span className="text-red-500">*</span>
                </label>
                <div className="mt-2">
                  <textarea
                    id="needleStickInjury"
                    name="needleStickInjury"
                    rows={6}
                    onChange={handleNeedleStickInjuryChange}
                    placeholder="Provide detailed information about the needle stick injury, including when and where it occurred, the type of needle or sharp object involved, and any immediate actions taken..."
                    required
                    className="block w-full rounded-md bg-white px-3 py-2.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:text-sm/6"
                  />
                </div>
                <p className="mt-2 text-sm text-gray-500">
                  Include details such as date, time, location, type of device, patient status (if known), and immediate response measures taken.
                </p>
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex items-center justify-center gap-x-4 border-t border-gray-200 px-6 py-4 sm:px-10">
              <button
                type="submit"
                disabled={isSubmitting}
                className="inline-flex items-center gap-x-2 rounded-md bg-red-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? (
                  <>
                    <svg className="animate-spin -ml-0.5 size-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>Submitting...</span>
                  </>
                ) : (
                  <>
                    <FaCheckCircle aria-hidden="true" className="-ml-0.5 size-5" />
                    <span>Submit Form</span>
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NeedleStickInjuryForm;
